import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e39bfde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FailedFetch" }
const _hoisted_2 = { class: "FailedFetch__content" }
const _hoisted_3 = { class: "FailedFetch__text" }
const _hoisted_4 = { class: "FailedFetch__error" }
const _hoisted_5 = { class: "error__text error__url" }
const _hoisted_6 = { class: "error__text error__message" }
const _hoisted_7 = { class: "error__text error__message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, "URL: " + _toDisplayString(_ctx.errorUrl || 'Не обнаружено'), 1),
        _createElementVNode("p", _hoisted_6, " Message: " + _toDisplayString(_ctx.errorMessage || _ctx.HTTP_ERROR_MESSAGE), 1),
        _createElementVNode("p", _hoisted_7, " Status code: " + _toDisplayString(_ctx.errorStatus || 'Не обнаружено'), 1)
      ]),
      _createVNode(_component_the_button, {
        loading: _ctx.loading,
        class: "primary small mt-3",
        onClick: _ctx.emitRefresh
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Попробовать ещё раз ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}